import { Fieldset, FormControl, Input, InputOption, Select } from "@visa/vds";
import EmailRegrex from "_constants/EmailValidationRegrex";
import EmailValidationRegrex from "_constants/EmailValidationRegrex";
import { DEFAULT_COUNTRY_CODE } from "_constants/GlobalConstants";
import { ValidationPatterns, ValidationMessages, FieldLimits } from "_constants/ValidationConstants";
import { FormHelper } from "_helpers/FormHelper";
import MCSControlInput from "components/MCSControlInput";
import MCSControlSelect from "components/MCSControlSelect";
import { useAuthContextUser } from "context/AuthContext";
import "flag-icon-css/css/flag-icon.min.css";
import React from "react";

// Validation functions using centralized constants
const validateName = (value) => {
  if (!value || value.trim().length === 0) return ValidationMessages.REQUIRED;
  if (value.trim().length < FieldLimits.NAME_MIN) return ValidationMessages.NAME_MIN_LENGTH;
  if (value.trim().length > FieldLimits.NAME_MAX) return ValidationMessages.NAME_MAX_LENGTH;
  if (!ValidationPatterns.NAME.test(value.trim())) return ValidationMessages.NAME_INVALID_CHARS;
  return true;
};

const validateBusinessTitle = (value) => {
  if (!value) return true; // Optional field
  if (value.trim().length > FieldLimits.BUSINESS_TITLE_MAX) return ValidationMessages.BUSINESS_TITLE_MAX_LENGTH;
  if (!ValidationPatterns.BUSINESS_TITLE.test(value.trim())) return ValidationMessages.BUSINESS_TITLE_INVALID_CHARS;
  return true;
};

const validateEmail = (value) => {
  if (!value || value.trim().length === 0) return ValidationMessages.REQUIRED;
  if (value.length > FieldLimits.EMAIL_MAX) return ValidationMessages.EMAIL_MAX_LENGTH;
  if (!EmailRegrex.validEmailFormat.test(value)) return ValidationMessages.EMAIL_INVALID_FORMAT;
  if (!EmailRegrex.coporateEmail.test(value)) return ValidationMessages.EMAIL_CORPORATE_ONLY;
  return true;
};

const validatePhoneNumber = (value) => {
  if (!value) return true; // Optional field
  if (value.trim().length === 0) return true; // Allow empty
  if (value.length > FieldLimits.PHONE_MAX) return ValidationMessages.PHONE_MAX_LENGTH;
  // Use flexible phone pattern that allows common formatting
  if (!ValidationPatterns.PHONE_FLEXIBLE.test(value)) return ValidationMessages.PHONE_INVALID_FORMAT;
  return true;
};

const validateCountry = (value) => {
  // Country is optional, but if provided should be valid
  return true;
};

const ContactSection = ({ isReadOnly, errors, register, control, sectionName, updateFormData, countries, getValues }) => {


  return (
    <>
      <Fieldset>
        <FormControl position="left" space="fifty">
          <MCSControlInput
            readOnly={isReadOnly}
            control={control}
            label="First Name*"
            name={sectionName + ".firstName"}
            handleChange={updateFormData}
            rules={{
              validate: validateName
            }}
          />
        </FormControl>
        <FormControl position="left" space="fifty">
          <MCSControlInput
            readOnly={isReadOnly}
            control={control}
            label="Last Name*"
            name={sectionName + ".lastName"}
            handleChange={updateFormData}
            rules={{
              validate: validateName
            }}
          />
        </FormControl >
        <FormControl position="left" space="fifty">
          <MCSControlInput
            control={control}
            register={register}
            readOnly={isReadOnly}
            label="Business Title"
            name={sectionName + ".businessTitle"}
            handleChange={updateFormData}
            rules={{
              validate: validateBusinessTitle
            }}
          />
        </FormControl>
        <FormControl position="left" space="fifty">
          <MCSControlInput
            readOnly={isReadOnly}
            control={control}
            label="Business Email*"
            name={sectionName + ".email"}
            handleChange={updateFormData}
            type="email"
            rules={{
              validate: validateEmail
            }}
          />
        </FormControl>
        <FormControl position="left" space="fifty">
          {!isReadOnly
            ? <MCSControlSelect
              name={sectionName + ".countryCode"}
              register={register}
              control={control}
              label="Country"
              handleChange={updateFormData}
              options={
                <>
                  <option value="" selected>
                    - Select -
                  </option>
                  {countries && countries.map((country, k) => (
                    <option key={k} value={country.id}>
                      {country.countryName.trim()}
                    </option>
                  ))}
                </>
              }
            />
            : <Select label="Country" readOnly={true} value={countries.find(x => x.id == getValues(sectionName).countryCode)?.countryName} />

          }
        </FormControl>

        <FormControl position="left" space="fifty">
          <MCSControlInput
            readOnly={isReadOnly}
            control={control}
            register={register}
            label="Business Phone Number"
            name={sectionName + ".phoneNumber"}
            handleChange={updateFormData}
            rules={{
              validate: validatePhoneNumber
            }}
          />
        </FormControl>
      </Fieldset>
    </>
  )
};

export default ContactSection;
